import type { Observable as ObservableType } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import type { Sprint } from '../../model/types';
import fetch from '../../rest/velocity-data-fetch';
import type { Response } from '../../rest/velocity-data-fetch/types';
import { getBaseUrl, getBoardId } from '../../state/selectors/base';
import type { MiddlewareAPI } from '../../state/types';

export const transformer = (data: Response): Sprint[] =>
	data.sprints.reverse().map((sprint) => {
		const statsData = data.velocityStatEntries[String(sprint.id)];

		return {
			id: sprint.id,
			name: sprint.name,
			estimated: statsData.estimated.value,
			completed: statsData.completed.value,
		};
	});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (store: MiddlewareAPI): ObservableType<Sprint[]> => {
	const state = store.getState();
	const baseUrl = getBaseUrl(state);
	const boardId = getBoardId(state);

	return fetch(baseUrl, boardId).map(transformer);
};
